// import Cookies from '/src/utils/cookies'
import actions from './actions'
import getters from './getters'
import * as types from './mutation_types'

const state = {
  // это просто схема-лесс объект, полями которого управляют действия вариаций
  variationActionsDomain: {},
  activeTestsWithVariations: {},
  yandexABFlagsInitCount: 0,
}

const mutations = {
  [types.UPDATE_VARIATIONS_DOMAIN_FULLY] (state, data) {
    state.variationActionsDomain = data
  },
  [types.SET_TESTS_VARIATIONS_FULLY] (state, data) {
    state.activeTestsWithVariations = data
  },
  [types.SET_YANDEX_AB_INIT_COUNT] (state, value) {
    state.yandexABFlagsInitCount = value
  },
  [types.SET_AB_FLAGS] (state, flags) {
    for (const [key, value] of Object.entries(flags)) {
      state[key] = value[0]
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
